module.exports = __webpack_public_path__ + "img/Sin título_1.3.2.d1d61674.jpg";